import React from "react";
import {Badge, CardBody, CardText, CardTitle} from "reactstrap";

const AddressCard = ({data}) => {
  const {
    street_address1 = "",
    is_mailing = false,
    is_billing = false,
    is_shipping = false,
    country = "",
    state = "",
    city = "",
    zip_code = "",
  } = data;

  return (
    <CardBody>
      <CardTitle tag="h3">
        Address
        <br />
        <CardText>{street_address1}</CardText>
        <br />
        <Badge color="" className="badge-dot mr-4 ml-1">
          <CardTitle tag="h4">
            Mailing
            {is_mailing ? (
              <i className="bg-success" style={{marginLeft: "10%"}} />
            ) : (
              <i className="bg-warning" style={{marginLeft: "10%"}} />
            )}
          </CardTitle>
        </Badge>
        <Badge color="" className="badge-dot mr-4 ml-1">
          <CardTitle tag="h4">
            Billing
            {is_billing ? (
              <i className="bg-success" style={{marginLeft: "10%"}} />
            ) : (
              <i className="bg-warning" style={{marginLeft: "10%"}} />
            )}
          </CardTitle>
        </Badge>
        <Badge color="" className="badge-dot mr-4 ml-1">
          <CardTitle tag="h4">
            Shipping
            {is_shipping ? (
              <i className="bg-success" style={{marginLeft: "10%"}} />
            ) : (
              <i className="bg-warning" style={{marginLeft: "10%"}} />
            )}
          </CardTitle>
        </Badge>
      </CardTitle>
      <CardTitle tag="h4">
        City <CardText>{city}</CardText>{" "}
      </CardTitle>
      <CardTitle tag="h4">
        State <CardText>{state}</CardText>{" "}
      </CardTitle>
      <CardTitle tag="h4">
        Country <CardText>{country}</CardText>
      </CardTitle>
      <CardTitle tag="h4">
        ZIP code <CardText>{zip_code}</CardText>
      </CardTitle>
    </CardBody>
  );
};

export default AddressCard;
